import axios from "axios";
import { Promise } from "q";
import { API_URL, STATUS_OK } from "../../config";

export default class ResetPasswordService {
    static resetPassword = (email, password, code) => {
        return new Promise((resolve, reject) => {
            axios
                .post(API_URL + "resetPassword", {
                    email,
                    password,
                    code
                })
                .then(response => {
                    if (response.status === STATUS_OK) resolve(response.data);
                    else reject(response);
                })
                .catch(error => {
                    reject(error);
                });
        });
    };
}
